import React, {Component} from 'react';
import '../../styles/Home.css'
import {Link} from "react-router-dom";

export default class RealizacjaTPayMiesieczne extends Component {

    constructor(props) {
        super(props);

        sessionStorage.removeItem('platnosc')
    }

    render() {
        return <div className="rezerwacjaPomyslnie" id='divToPrint' style={{border: 'none'}}>
            <h2><i className="fa fa-2x fa-check" style={{marginRight: 25}}> </i>Dziękujemy za skorzystanie z naszych
                usług</h2>
            <h5 style={{padding: 10, fontWeight: 400}}>Dane zakupu oraz potwierdzenie zostaną wysłane po zaksięgowaniu
                wpłaty na podany adres
                e-mail: <b>{JSON.parse(sessionStorage.getItem('loggedIn')).login}</b></h5>
            {sessionStorage.getItem('loggedIn') !== undefined && sessionStorage.getItem('loggedIn') !== null ?
                <p>Aby wyświetlić wszystkie bilety przejdź do zakładki <b><Link to={'/konto/bilety/miesieczne'}>Moje
                    bilety</Link></b></p> : null}

        </div>

    }

}



// WEBPACK FOOTER //
// ./src/components/koszyk/finalizacja/RealizacjaTPayMiesieczne.js